module.exports = __webpack_public_path__ + "img/phone-haulage-3.04dfb1d9.png";